import { AppHeader } from "@/components/layout";
import { Card, Skeleton } from "@/components/ui";

export function DashboardSkeleton() {
  return (
    <>
      <AppHeader />
      <main className="mx-auto max-w-7xl p-6">
        <div className="mb-6 flex justify-between">
          <div className="space-y-2">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="h-4 w-56" />
          </div>
          <Skeleton className="h-7 w-24" />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton key={`kpi-${index}`} className="h-28 w-full rounded-md" />
          ))}
        </div>
        <div className="mt-6 grid gap-4 xl:grid-cols-3">
          <Card className="xl:col-span-2">
            <Skeleton className="h-6 w-20" />
            <Skeleton className="mt-4 h-60 w-full" />
          </Card>
          <Card>
            <Skeleton className="h-6 w-32" />
            <div className="mt-4 space-y-4">
              {Array.from({ length: 5 }, (_, index) => <Skeleton key={`product-${index}`} className="h-10 w-full" />)}
            </div>
          </Card>
        </div>
        <Card className="mt-6">
          <Skeleton className="h-6 w-36" />
          <div className="mt-4 space-y-4">
            {Array.from({ length: 5 }, (_, index) => <Skeleton key={`order-${index}`} className="h-8 w-full" />)}
          </div>
        </Card>
      </main>
    </>
  );
}
